<template>
  <div class="returnPolicy">
    <v-container>
      <h1 class="text-center mb-6 pink--text">退換貨條款</h1>
      <p>本網站之商品屬於貼身衣物，符合消保法下列不得退換貨之第六種狀況，無七天猶豫期，固恕不接受退換貨。</p>
      <p>按照消保法的規定，通訊交易（例如網路購物、電視購物）的消費者，可以在收受商品或服務後，於7天內退回商品、解除契約。但是，有些商品因為保存、衛生問題，會有例外不能在7天內退換貨的狀況，包含以下幾種：</p>
      <ul>
        <li>商品易於腐敗、保存期限較短，或解約時即將逾期
          <p>例如生鮮食品，保存期限較短，若解約後將讓店家無法再次出售，會有損失。</p>
        </li>
        <li>客製化給付
          <p>量身訂作的商品，例如刻有名字的印章，無法再賣給別人。</p>
        </li>
        <li>報紙、期刊或雜誌
          <p>具有時效的出版品，一旦時間過了，裡面的資訊就會過時。</p>
        </li>
        <li>經消費者拆封之影音商品或電腦軟體
          <p>消費者方便複製檔案，所以即使退實體的商品，也無法達到退還電子檔的效果。</p>
        </li>
        <li>
          <p>非以有形媒介提供之數位內容或一經提供即為完成之線上服務，經消費者事先同意始提供。
        例如購買付費應用程式（App），電子書，這些可以在購買後下載取得的東西，現實上很難還給商家，所以原則上不適用七日鑑賞期。</p>
        </li>
        <li>已拆封之個人衛生用品
          <p>例如刮鬍刀、貼身衣物，因為衛生考量，一旦有使用或穿著過，就不適合由店家回收後再販賣。</p>
        </li>
        <li>國際航空客運服務
          <p>由於航空業作為全球化產業，跟一般商品或服務不同，所以有另外針對航空業的法令來規範。</p>
        </li>
      </ul>
    </v-container>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.returnPolicy {
  .container {
    padding: 40px;
    margin: 40px auto;
    max-width: 1200px;
    min-height: 500px;
    background-color: white;
    color: black;
    h1 {
      font-weight: 500 !important;
    }
    p {
        color: black !important;
    }
    h4 {
        color: $main;
    }
    a {
        color: $main !important;
    }
  }
}
</style>